import React, {useState} from "react";

import Loading from "../Loading";
import PaginationTable from "../Pagination";

import i18n from "i18next";

import {useQuery} from 'react-query';
import {Buttons} from "components/Buttons";
import {getGoals} from "../../services/Goals.service";

function Table({
                   selected,
                   status = '',
                   trashed = 0,
                   param,
               }) {

    const [data, setData] = useState([]);
    const [paginate, setPaginate] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);

    const key = status ? status : trashed && "trashed"

    const filter = selected ? selected?.replace('+', '%2B') : '';

    const {isLoading, isFetching} = useQuery([param, key, currentPage, filter],
        () => {
            return getGoals(status, currentPage, filter, trashed)
        }, {
            onSuccess: (res) => {
                if (res) {
                    const {data} = res
                    setData(data?.data)
                    setPaginate(data?.meta)
                }
            },
            onError: () => {
                //  toast.error(i18n.t('error.badRequest'));
            },
            retry: false,
            refetchOnWindowFocus: false,
            keepPreviousData: true,
        }
    )

    const handlePageClick = (event) => {
        setCurrentPage(event.selected + 1)
    };


    if (isLoading) return <Loading/>

    return (
        <div className="accordion accordion-flush shadow-sm rounded mt-3" id={`accordion-${status}-${param}`}>
            <div className="accordion-item rounded">
                <h2 className="accordion-header" id={`heading-${status}-${param}`}>
                    <button className={`accordion-button rounded-top ${!selected && "collapsed"} `}
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#panel-${status}-${param}`} aria-expanded={!!selected}
                            aria-controls="flush-collapseOne">
                        <h5 className="m-0">
                            {i18n.t(`header.${status ? status : 'delete'}`)}
                        </h5>
                    </button>
                </h2>
                <div id={`panel-${status}-${param}`} className={`accordion-collapse collapse ${selected && "show"}`}
                     aria-labelledby={`heading-${status}-${param}`} data-bs-parent={`#accordion-${status}-${param}`}>
                    <div className="accordion-body p-0">
                        <div className="table-responsive">
                            <table
                                className={`table table-hover align-middle mb-0 ${isFetching && "text-muted"}`}>
                                <tbody>

                                {!data.length &&
                                    <tr>
                                        <td>{i18n.t('upload.tableRecords')}</td>
                                    </tr>
                                }

                                {data?.map(item =>
                                    <tr key={item.id}>
                                        <td className="text-wrap"><span className="text-muted fw-bolder">{item.codigo}  - </span> {param === 'goals' ? item.titulo_meta : item.titulo}</td>
                                        <td>
                                            <Buttons
                                                trashed={trashed}
                                                id={item.id}
                                                title={item.titulo_meta}
                                                isFetching={isFetching}
                                                param={param}
                                                status={item.status}
                                            />
                                        </td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        </div>

                        {data.length > 0 &&
                            <div className="py-3">
                                <PaginationTable
                                    isFetching={isFetching}
                                    paginate={paginate}
                                    handlePageClick={handlePageClick}
                                />
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Table;
